import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const Scatter = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="Scatter"
    {...props}
  >
    <g clipPath="url(#clip0_961_32938)">
      <path d="M6.66667 4V25.3333H28V28H4V4H6.66667Z" fill="#394959" />
      <circle cx={12} cy={20} r={2} fill="#394959" />
      <circle cx={16} cy={14} r={2} fill="#394959" />
      <circle cx={22} cy={12} r={2} fill="#394959" />
      <circle cx={19} cy={19} r={2} fill="#394959" />
      <circle cx={26} cy={7} r={2} fill="#394959" />
    </g>
    <defs>
      <clipPath id="clip0_961_32938">
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default React.memo(Scatter);
